export default __webpack_public_path__ + "b60676fe126a798b7f68655497464b41.png";